export const EDIT_PROFILE_SUCCESS_MESSAGE = "Details successfully updated";
